import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../../services/auth/authorisation";

/**
 * MenuBarItem component.
 *
 * This component renders a menu item button that navigates to the specified route when clicked.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.text - Text for the button label.
 * @param {string} props.route - Route to navigate to when the button is clicked.
 *
 * @returns {JSX.Element} - The JSX element for the menu item button.
 */
function MenuBarItem({ text, route }) {
  const navigate = useNavigate();

  return (
    <Button key={text} onClick={() => navigate(route)} sx={{ my: 2, color: "white", display: "block" }}>
      {text}
    </Button>
  );
}

/**
 * MenuBar component.
 *
 * This component renders a navigation bar with an icon and menu items.
 *
 * @returns {JSX.Element} - The JSX element for the menu bar.
 */
function MenuBar() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" color="secondary">
        <Toolbar>
          <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 0 }}>
            <Box
              component="img"
              sx={{ height: "4rem", width: "100%" }}
              src="https://preview.redd.it/gsg71myc1s601.png?auto=webp&s=da664cd405b2f5c51fed90e3b26cebcee9ec82fa"
            />
          </IconButton>

          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            <MenuBarItem text={"Dashboard"} route={"/dashboard"} />
            <MenuBarItem text={"Tasks"} route={"/tasks"} />
            <MenuBarItem text={"Logs"} route={"/logs"} />
            <MenuBarItem text={"Export Json"} route={"/export-json"} />
            <MenuBarItem text={"DevTools"} route={"/dev-tools"} />
            <MenuBarItem text={"Auto4client"} route={"/auto4client"} />
            <MenuBarItem text={"Admin"} route={"/admin"} />
            <MenuBarItem text={"Data Uploader"} route={"/data-uploader"} />
            <MenuBarItem text={"Geocoder"} route={"/geocoder"} />
            <MenuBarItem text={"Data Checker"} route={"/data-checker"} />
            <MenuBarItem text={"Sheet Generator"} route={"/sheet-generator"} />
          </Box>

          <MenuBarItem text={"Settings"} route={"/settings"} />
          <Button
            color="inherit"
            onClick={async () => {
              await logoutUser();
              window.location.reload();
            }}
            sx={{ my: 2, color: "white", display: "block" }}
          >
            Log Out
          </Button>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default MenuBar;
